import useLocalStorage from "/src/hooks/useLocalStorage";
import accountService from "../services/accountService";
import userService from "../services/userService";
import storage from '/src/utils/storage';
import {actualizeTitle} from "/src/utils/actualizeTitle"
import { useEffect } from 'react';
//import { toastSuccess, toastError } from "/src/layouts/toast/action/toastAction";

async function changePassword(data) {

    let [response, error] = await accountService.updateMyAccount(data);

    if (error !== null) {
        return false;
    }

    return response;
}

async function refreshUserInformation(data) {

    let [response, error] = await userService.refreshInfoUser(data);

    if (error !== null) {
        return false;
    }

    return response;
}

async function changeCompany(company_id) {
    const [data, error] = await accountService.updateMyAccount({company_id: company_id })
    if (error !== null) {
        console.log(error);
        return {error : "error"};
    }
    const { user, company, permissions } = data;
    storage('session').set('company', company);
    storage('session').set('permissions', permissions);
    actualizeTitle();
    return  { user, company, permissions }
}

export default { changePassword, refreshUserInformation,changeCompany }